'use client'

import { useEffect, useState } from 'react'

import { ArticleSearchDTO } from '@/lib/models/model-types/page-search/pageSearch.types'
import { CardSearchResult } from '@/lib/ui-kit/components/CardSearchResult.component'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/lib/ui-kit/components/ui/pagination'

const PER_PAGE = 18

export const ArticlesSearchResults = ({
  articlesAll,
}: {
  articlesAll: ArticleSearchDTO[]
}) => {
  const [articles, setArticles] = useState(articlesAll)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    setArticles(articlesAll)
    setCurrentPage(1)
  }, [articlesAll])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [currentPage])

  const articlesPageCurrent = articles.slice(
    (currentPage - 1) * PER_PAGE,
    currentPage * PER_PAGE,
  )

  const totalPages = Math.ceil(articles.length / PER_PAGE)

  return (
    <>
      <section className="grid grid-cols-1 gap-x-5 gap-y-12 sm:grid-cols-2 md:grid-cols-3 xl:pr-10">
        {articles &&
          articlesPageCurrent.map((article) => {
            return (
              <CardSearchResult
                key={article.id}
                category={article.category}
                title={article.title}
                description={article.description}
                authorName={article.authorName}
                datePublication={article.datePublication}
                linkArticle={article.linkArticle}
                image={article.imageCard}
              />
            )
          })}
      </section>
      <div className="p-6 xl:pl-10 xl:pt-12">
        <Pagination>
          <PaginationContent>
            <div className="hidden xl:flex">
              {Array.from({ length: totalPages }, (_, i) => (
                <PaginationItem
                  className={`mr-3 flex cursor-pointer items-center space-x-4 rounded-full border px-7 py-5 ${
                    i === currentPage - 1
                      ? ' border-gray-1000'
                      : 'border-gray-200'
                  }`}
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  <PaginationLink className="">{i + 1}</PaginationLink>
                </PaginationItem>
              ))}
            </div>

            {articles.length > PER_PAGE && (
              <div className="flex flex-1 justify-between xl:items-center xl:justify-end xl:gap-4">
                <PaginationItem
                  className={`flex cursor-pointer items-center rounded-full`}
                  onClick={() =>
                    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
                  }
                >
                  <PaginationPrevious isDisabled={currentPage === 1} />
                </PaginationItem>
                <PaginationItem
                  className={`flex cursor-pointer items-center rounded-full`}
                  onClick={() =>
                    setCurrentPage((prevPage) =>
                      Math.min(prevPage + 1, totalPages),
                    )
                  }
                >
                  <PaginationNext isDisabled={currentPage === totalPages} />
                </PaginationItem>
              </div>
            )}
          </PaginationContent>
        </Pagination>
      </div>
    </>
  )
}
